import { Card, List } from "antd";
import { getAvailabilityColor } from "../../modules/getAvailabilityColor";

export const AvailabilityAlertToday = (props) => {
  const { overbookedRooms } = props;
  return (
    <Card title="Availability Alert Today" bordered>
      {overbookedRooms.length > 0 ? (
        <List
          dataSource={overbookedRooms}
          renderItem={(room) => (
            <List.Item>
              <List.Item.Meta
                title={
                  <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                    {room.name}
                  </span> // Room name styling
                }
                description={
                  <span>
                    Availability:
                    <span
                      style={{
                        fontSize: "24px",
                        fontWeight: "bold",
                        marginLeft: "8px",
                      }}
                    >
                      {room.availability}
                    </span>
                  </span>
                }
              />
              <div
                style={{
                  backgroundColor: getAvailabilityColor(room.availability),
                  width: "20px",
                  height: "20px",
                  borderRadius: "50%",
                }}
              ></div>
            </List.Item>
          )}
        />
      ) : (
        <p>No availability data for today.</p>
      )}
    </Card>
  );
};
